class WebsocketService {

  static WS_BASE_URL = process.env.REACT_APP_API_URL
    .replace(/\/$/, "")
    .replace("https://", "wss://")
    .replace("http://", "ws://");

  agentAssistChat() {
    return `${WebsocketService.WS_BASE_URL}/agent-assist/chat`;
  }

  clientAssistChat() {
    return `${WebsocketService.WS_BASE_URL}/agent-assist/client-chat`;
  }
}

export default new WebsocketService();
